import { render, staticRenderFns } from "./ZreportsPage.vue?vue&type=template&id=47e05618&scoped=true&lang=html&"
import script from "./ZreportsPage.vue?vue&type=script&lang=js&"
export * from "./ZreportsPage.vue?vue&type=script&lang=js&"
import style0 from "./ZreportsPage.vue?vue&type=style&index=0&id=47e05618&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e05618",
  null
  
)

export default component.exports